import { TextInput, TextInputProps } from '@mantine/core';
import styles from './styles.module.css';

export const EmailInput = (props: TextInputProps) => {
	const forceLowercase = (e: React.KeyboardEvent<HTMLInputElement>) => {
		e.currentTarget.value = e.currentTarget.value?.toLowerCase?.();
	};
	return (
		<TextInput
			className={styles.emailInput}
			onKeyUp={forceLowercase}
			autoCapitalize="none"
			{...props}
		/>
	);
};
